import type {
  ListMarketViewSummariesResponse,
  MarketViewApiListMarketViewSummariesData,
} from '@blk/aladdin-graph-client-axios-internal/wealth/analytics/market_views/v2/market_view_api';
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_MARKET_VIEWS_API_URL } from './Constants';
import type { MarketViewsResponse } from './types';

export type MarketViewSummariesParams = MarketViewApiListMarketViewSummariesData['query'];

export const awMarketViewsApi = axios.create();

export const awMarketViewsSettings: AGraphApiSettings = {};

awMarketViewsApi.interceptors.request.use((config) => {
  const { getAladdinApiKey, getEnvTypeFn, getConfigurationDirectoryFn } = awMarketViewsSettings;
  const baseURL = AW_MARKET_VIEWS_API_URL;
  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      overrideConfigDirectory: getConfigurationDirectoryFn?.(),
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());
  return updatedConfig;
});
/**
 * V1: Returns flat market view breakdowns.
 * @deprecated Use getMarketViewSummariesApi instead. Will be removed once V2 is fully rolled out.
 */
export const getMarketViews = (pkg: string, lng?: string): Promise<AxiosResponse<MarketViewsResponse>> =>
  awMarketViewsApi.get('/v1/marketViews', { params: { pkg, locale: lng } });

/**
 * V2: Returns a paginated list of market view summaries with snapshot data embedded.
 * @param params - Query parameters including pkg (required), pageSize (optional), pageToken (optional)
 */
export const getMarketViewSummariesApi = (
  params: MarketViewSummariesParams
): Promise<AxiosResponse<ListMarketViewSummariesResponse>> =>
  awMarketViewsApi.get('/v2/marketViewSummaries', { params });
